'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CreditRequestController = function () {
  function CreditRequestController(formUpload, $rcAlerts, $window) {
    'ngInject';

    (0, _classCallCheck3.default)(this, CreditRequestController);
    this.$rcAlerts = $rcAlerts;
    this.$window = $window;
    this.formUpload = formUpload;
    this.files = [];
    this.form = {
      sigDate: new Date()
    };
  }

  (0, _createClass3.default)(CreditRequestController, [{
    key: 'submit',
    value: function submit() {
      var ctrl = this;
      var url = '/sps/jas/unsecured/credit-request';
      if (ctrl.formValid.$valid) {
        ctrl.formUpload.uploadFormToUrl(this.form, this.files, url).success(function () {
          ctrl.$rcAlerts.success('Credit Request Submitted!');
          ctrl.$window.scrollTo(0, 0);
          ctrl.reset();
        }).error(function () {
          ctrl.$rcAlerts.error('Credit Request Failed!');
          ctrl.$window.scrollTo(0, 0);
        });
      } else {
        ctrl.$rcAlerts.error('Please fill out all required fields');
        ctrl.$window.scrollTo(0, 0);
      }
    }
  }, {
    key: 'addFile',
    value: function addFile() {
      this.files.push(null);
    }
  }, {
    key: 'deleteFile',
    value: function deleteFile(idx) {
      this.files.splice(idx, 1);
    }
  }, {
    key: 'reset',
    value: function reset() {
      this.files = [];
      this.form = {
        sigDate: new Date()
      };
    }
  }]);
  return CreditRequestController;
}();

exports.default = CreditRequestController;
;


// WEBPACK FOOTER //
// ./src/credit-request/credit-request.controller.js